import localeText from "../../../locale";
import GetInfoService from "../../../service/GetInfoService";

export const useRegisterValidation = (toast) => {
  const getInfoService = new GetInfoService();

  const validateEmail = (email, emailRef) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("invalidEmail"),
        life: 6000,
      });
      if (emailRef?.current) emailRef.current.style.border = "1px solid red";
      return false;
    }
    if (emailRef?.current) emailRef.current.style.border = "1px solid #46a748";
    return true;
  };

  const findReferral = async (username, referralRef, setReferralIconSpinner) => {
    if (!username) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("referralUserNotFound"),
        life: 6000,
      });
      setReferralIconSpinner("pi pi-times");
      if (referralRef?.current) referralRef.current.style.border = "1px solid red";
      return false;
    }

    try {
      const res = await getInfoService.getFindReferral(username);

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("referralUserNotFound"),
          life: 6000,
        });
        setReferralIconSpinner("pi pi-times");
        if (referralRef?.current) referralRef.current.style.border = "1px solid red";
        return false;
      } else {
        setReferralIconSpinner("pi pi-check");
        if (referralRef?.current) referralRef.current.style.border = "1px solid #46a748";
        return true;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("referralUserNotFound") || "Erro ao verificar indicação. Verifique sua conexão.",
        life: 6000,
      });

      setReferralIconSpinner("pi pi-times");
      if (referralRef?.current) referralRef.current.style.border = "1px solid red";
      return false;
    }
  };

  const findUsername = async (username, usernameRef, setUsernameIconSpinner) => {
    if (username.length === 0 || !/^[a-z0-9]+$/.test(username)) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("usernameCantBeEmpty"),
        life: 8000,
      });
      setUsernameIconSpinner("pi pi-times");
      if (usernameRef?.current) usernameRef.current.style.border = "1px solid red";
      return false;
    }

    try {
      const res = await getInfoService.getFindUsername(username);

      if (res.messageCode === 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("usernameNotAvailable"),
          life: 6000,
        });
        setUsernameIconSpinner("pi pi-times");
        if (usernameRef?.current) usernameRef.current.style.border = "1px solid red";
        return false;
      } else {
        setUsernameIconSpinner("pi pi-check");
        if (usernameRef?.current) usernameRef.current.style.border = "1px solid #46a748";
        return true;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  return {
    validateEmail,
    findReferral,
    findUsername,
  };
};

